import { Action } from 'redux';

import {
  OpenConnectedApplicationDialog,
  ToggleConnectedApplicationEnablement
} from '~src/app/actions/AppActionTypes';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { IDeleteAction } from '~src/ts/ServerApi/types/actionNames';

import { Messages } from '../../codegen/Localize';
import { IConnectedApplicationInfo } from '../models/ConnectedApplicationInfo';

// Type is only used by generic infra and as such does not need to know of the other valid action types
export type ConnectedApplicationMenuActions = Readonly<
  IDeleteAction
>;

export interface OpenConnectedApplicationDialogAction extends Action {
  previous?: IConnectedApplicationInfo;
}

export function createNewConnectedApplication(): OpenConnectedApplicationDialogAction {
  return {
    type: OpenConnectedApplicationDialog
  };
}

export function editConnectedApplication(application: IConnectedApplicationInfo): OpenConnectedApplicationDialogAction {
  return {
    type: OpenConnectedApplicationDialog,
    previous: application,
  };
}

export interface ToggleConnectedApplicationEnablementAction extends Action {
  application: IConnectedApplicationInfo;
}

export function toggleConnectedApplicationEnablement(application: IConnectedApplicationInfo): ToggleConnectedApplicationEnablementAction {
  return {
    type: ToggleConnectedApplicationEnablement,
    application,
  };
}

export const ConnectedApplicationEditAction: IEntityAction<IConnectedApplicationInfo, {}> = {
  name: EntityActionNames.Edit,
  translateName: Messages.connectedApplicationsEditConnectedAppMenu,
  isVisible: () => true,
  isClickable: (_: {}, items: IConnectedApplicationInfo[]) => items.length === 1,
  createReduxAction: items => editConnectedApplication(items[0]),
};

export const ToggleConnectedApplicationEnablementAction: IEntityAction<IConnectedApplicationInfo, {}> = {
  name: EntityActionNames.ConnectedApplicationToggleEnablement,
  translateName: items => items[0].enabled ? Messages.connectedApplicationsDisableConnectedAppMenu(): Messages.connectedApplicationsEnableConnectedAppMenu(),
  isVisible: () => true,
  isClickable: (_: {}, items: IConnectedApplicationInfo[]) => items.length === 1,
  createReduxAction: items => toggleConnectedApplicationEnablement(items[0]),
};

